<template>
  <div v-if="isPreview" :class="['link', 'is-previewing', { active }]">
    <FriedIcon v-if="item.icon" :icon="item.icon" class="icon" />
    <span class="link-text">
      {{ item.label }}
    </span>
  </div>
  <router-link
    v-else
    v-wave
    v-tooltip="{
      content: item.tooltip,
      placement: Placement.Bottom,
      distance: 8,
      delay: { show: 300, hide: 100 },
    }"
    :data-external="`dsr-navigation-item-${item.key}`"
    :class="['link', { active }]"
    :to="getLinkToUpdateView(item.key)"
  >
    <FriedIcon v-if="item.icon" :icon="item.icon" class="icon" />
    <span class="link-text">
      {{ item.label }}
    </span>
    <slot name="notification" />
  </router-link>
</template>
<script setup lang="ts">
import type { IconName } from '@getaccept/fried-tofu';
import { Placement } from '@getaccept/fried-tofu';
import { useRoute } from 'vue-router';
import type { DrView } from '../types';

const { active, item, isPreview } = defineProps<{
  active?: boolean;
  item: {
    label: string;
    key: DrView;
    icon?: IconName;
    tooltip?: string;
  };
  isPreview?: boolean;
}>();

const route = useRoute();

const getLinkToUpdateView = (view: DrView) => ({
  name: route.name,
  params: { view, itemId: undefined, tab: undefined },
  query: route.query,
});
</script>

<style lang="scss" scoped>
.link {
  font-size: var(--paragraph-large-font-size);
  border-radius: var(--radius-medium);
  font-weight: 600;
  min-height: 2.5rem;
  text-decoration: none;
  cursor: pointer;
  padding: var(--spacing-50) var(--spacing-75);
  transition: background-color 0.1s ease-in-out;
  position: relative;
  display: flex;
  justify-content: center;
  color: var(--text-gray);
  margin-right: var(--spacing-25);

  @media screen and (max-width: $sm) {
    padding: var(--spacing-50);
    width: 100%;
  }

  h4 {
    font-size: var(--paragraph-large-font-size);
  }

  &:hover,
  &:focus {
    background-color: var(--gray-96);
  }

  &.is-previewing {
    pointer-events: none;
    user-select: none;
  }

  &.active {
    background-color: var(--info-light);
    color: var(--link-blue);

    &:hover {
      background-color: var(--info-light);
      color: var(--link-blue);
    }

    h4 {
      color: var(--link-blue);
    }
  }

  &:focus:not([data-focus-visible-added]) {
    outline: none;
  }

  .icon {
    margin-right: var(--spacing-50);
  }

  .link-text {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
